
import 'rxjs';
import * as actions from '../actions.js';


const generateUniqueNumber = (function generateGenerateUniqueNumber() {
        const alreadyUsed = new Set();
        return function actualUniqueNumberGenerator(n = 10000) {
            let attempt;
            do {
                attempt = Math.floor(Math.random() * n);
            } while ( alreadyUsed.has(attempt) );
            alreadyUsed.add(attempt);

            return attempt;
        };
    }());

export function transactionsInit() {
    const data = {
            utxos: [],
            keys: [],
            externalKey: {},
            outputs: [],
            serialized: "",
        },
        numKeys = Math.floor(Math.random() * 3) + 4,
        numUtxos = Math.floor(Math.random() * 7) + 5,
        availableColours = [0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'];

    // set up keys
    for( let i = 0; i < numKeys; i++ ) {
        const newKey = {
                name: 'key-' + generateUniqueNumber(200),
                color: availableColours.splice(Math.floor(Math.random() * availableColours.length), 1)[0],
                selected: false,
            };
        data.keys.push(newKey);
    }

    // add extra key representing a key owned by someone else
    data.externalKey = {
        name: 'key-' + Math.floor(Math.random() * 200),
        color: availableColours.splice(Math.floor(Math.random() * availableColours.length), 1)[0],
        selected: false,
    };

    // populate utxos
    for( let i = 0; i < numUtxos; i++ ) {
        const big = Math.random() < 0.3,
            external = Math.random() < 0.3,
            rawAmount = big ? (Math.random() * 100) : ((Math.random() * 100) / (Math.random() * 1000)),
            amount = Math.floor(rawAmount * 100000000) / 100000000,
            randomKey = Math.floor(Math.random() * data.keys.length),
            lockedBy = external ? data.externalKey.name : data.keys[randomKey].name,
            color = external ? data.externalKey.color : data.keys[randomKey].color,
            utxo = {
                id: 'utxo-' + generateUniqueNumber(),
                amount,
                lockedBy,
                selected: false,
                color,
            };
        data.utxos.push(utxo);
    }

    return Promise.resolve(actions.transactionInitialize(data));
}



// WEBPACK FOOTER //
// ./src/epics/transactions-epics.js